import React, { useRef } from "react";
import { businessMatchingRootPath, newPostPath, postsPath, studyGroupsPath, userPath } from "../../../../../../routes";
import SmsIcon from "../../icons/SmsIcon";

import { SharedCurrentUser } from "../../../lib/types";
import DehazeIcon from "../../icons/DehazeIcon";
import Button from "../../ui/Button";

import {
  Box,
  Circle,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  Link,
  Stack,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { DrawerProfile } from "./DrawerProfile";
import { DrawerProfileMenu } from "./DrawerProfileMenu";
import { DrawerListItem } from "./DrawerListItem";
import { DrawerLoginButton } from "./DrawerLoginButton";
import { DrawerLogoutButton } from "./DrawerLogoutButton";
import { DrawerArchitectRegistrationPrompt } from "./DrawerArchitectRegistrationPrompt";
import { DrawerArchitectApplicationRevisionPrompt } from "./DrawerArchitectApplicationRevisionPrompt";
import { DrawerArchitectApplicationPendingPrompt } from "./DrawerArchitectApplicationPendingPrompt";

const HeaderDrawerWithButton = ({
  currentUser,
  logout,
}: {
  currentUser: SharedCurrentUser | undefined;
  logout: () => void;
}) => {
  const btnRef = useRef<HTMLButtonElement>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Stack as="button" gap={0} align="center" ref={btnRef} onClick={onOpen}>
        <Flex boxSize="28px" align="center" justify="center" position="relative">
          <DehazeIcon />
          {currentUser?.is_unapproved && currentUser.latest_personal_info_application_rejected && (
            <Circle size="12px" bg="red.500" position="absolute" top={0} right="-4px" border="1px solid white" />
          )}
        </Flex>
        <Box fontSize="xs">メニュー</Box>
      </Stack>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xs">
        <DrawerOverlay />
        <DrawerContent maxW="80%">
          <DrawerCloseButton />
          <DrawerHeader pt={6} pb={4} fontWeight="normal" borderBottomWidth="1px" borderColor="#E2E8F0">
            <HStack mr={5} wordBreak="break-word">
              {currentUser && <DrawerProfile currentUser={currentUser} />}
            </HStack>
          </DrawerHeader>

          <DrawerBody py={0} px={0}>
            {currentUser?.is_unapproved && (
              <Box mt={6}>
                {currentUser.latest_personal_info_application_rejected ? (
                  <DrawerArchitectApplicationRevisionPrompt />
                ) : currentUser.personal_info_applicationing ? (
                  <DrawerArchitectApplicationPendingPrompt />
                ) : (
                  <DrawerArchitectRegistrationPrompt />
                )}
              </Box>
            )}
            {currentUser && (
              <Box mt={6}>
                <DrawerProfileMenu currentUser={currentUser} />
              </Box>
            )}
            <Box px={5} mt={5}>
              <Text fontSize="sm" fontWeight="bold">
                コンテンツ
              </Text>
              <Box mt={2}>
                <DrawerListItem as={Link} href={postsPath()}>
                  Q&A
                </DrawerListItem>
                {currentUser?.is_all_public_feature_accessible && (
                  <DrawerListItem as={Link} href={userPath(currentUser.code, { "qa-tab": "bookmarked" })}>
                    ブックマーク
                  </DrawerListItem>
                )}
                <DrawerListItem as={Link} href={studyGroupsPath()} onClick={onClose}>
                  勉強会
                </DrawerListItem>
                {currentUser?.is_show_business_matching_link && (
                  <DrawerListItem as={Link} href={businessMatchingRootPath()} onClick={onClose} isExternal>
                    協力事務所を探す（β版）
                  </DrawerListItem>
                )}
              </Box>
            </Box>
            {currentUser?.is_all_public_feature_accessible && (
              <VStack bgColor="brand.50" px={5} py={4} mb={-2}>
                <Box fontSize="xs">Q&Aで気軽に質問・コメントしてみましょう</Box>
                <Button w="full" size="sm" leftIcon={<SmsIcon />} iconSpacing={1} as="a" href={newPostPath()}>
                  質問を投稿
                </Button>
              </VStack>
            )}
            {currentUser && (
              <Box mt={2}>
                <DrawerLogoutButton logout={logout} />
              </Box>
            )}
            {!currentUser && (
              <Box mt={5}>
                <DrawerLoginButton />
              </Box>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default HeaderDrawerWithButton;
